var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 20,
    viewBox: "0 0 12 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.06339 19.0981V10.8875H10.9581L11.3915 7.68765H8.06331V5.64468C8.06331 4.71824 8.33348 4.08693 9.72893 4.08693L11.5086 4.08614V1.22422C11.2008 1.18529 10.1443 1.09814 8.91531 1.09814C6.34929 1.09814 4.59255 2.58932 4.59255 5.32787V7.68765H1.69043V10.8875H4.59255V19.0981H8.06339V19.0981Z",
    fill: "#064E3B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.f31336b3b6f6239e4b56986f0d2a39a5.svg";
export { ForwardRef as ReactComponent };